import React from "react";
import {AlertTooltip} from "./AlertTooltip";

export class ConversionsAlertTooltip extends AlertTooltip {
    render() {
        let tooltipContent = this.tooltipContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-marker">
                    <i className="fa fa-circle" aria-hidden="true"/>
                </div>
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <p className="alert-tooltip-title">{this.props.comparisonWithAverageValue}</p>
                    </div>
                    {tooltipContent}
                </div>
            </div>

        )
    }

    getTodayDetails() {
        const percentage = this.props.fluctuation === "down" ? " abajo" : " arriba";
        let result = [<span>Hoy se recibieron {this.props.dayValue} conversiones.</span>,<br/>,<br/>, <span>El acumulado del período es {this.props.value} vs el mes pasado que a esta altura había {this.props.expectedValue} conversiones.<br/><br/>{this.props.fluctuationPercentage}{percentage} con respecto al mes pasado.</span>];
        if (this.props.dayValueByType) {
            let details = []
            for (const [key, value] of Object.entries(this.props.dayValueByType)) {
                if (value !== null) {
                    if (value > 0)
                        details.push(<span key={key}>- {key}: {typeof value === "number" ? value.toFixed(2) : value}<br /></span>);
                }
            }
            if(details.length >0)
            {
                result.push(<br/>);
                result.push(<br/>);
                result.push(<span>Detalle de las conversiones del día {this.props.dayNumber}:</span>);
                result.push(<br/>);
                result = result.concat(details)
            }
        }

        const adAccountsWithTextStatus = [];

        if (this.props.valueByType) {
            let details = []
            for (const [key, value] of Object.entries(this.props.valueByType)) {
                if (value !== null) {
                    if (value > 0) {
                        details.push(<span key={key}>- {key}: {typeof value === "number" ? value.toFixed(2) : value}<br /></span>);
                    }

                    if (typeof value === 'string') {
                        const textValue = <span key={key}>- {key}: {value}<br/></span>;
                        adAccountsWithTextStatus.push(textValue);
                    }
                }
            }
            if(details.length >0)
            {
                result.push(<br/>);
                result.push(<br/>);
                result.push(<span>Detalle de las conversiones acumuladas:</span>);
                result.push(<br/>);
                result = result.concat(details)
            }

            if(adAccountsWithTextStatus.length >0) {
                result.push(<br/>);
                result.push(<br/>);
                result.push(<span>Aclaraciones:</span>);
                result.push(<br/>);
                result = result.concat(adAccountsWithTextStatus)
            }

        }

        if (this.props.trackUsingAnalytics) {
            result.push(<span>Nota: Esta línea de control obtiene los datos de Google Analytics.</span>);
        }

        return result
    }

    tooltipContent() {
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-description">
                    {this.getTodayDetails()}
                </p>
                {this.renderGoogleAnalyticsNotice()}
            </div>
        );
    }
}
